export const BREEDER_APPLICATION_IDS = {
  DEFAULT: 'BreederApplication--default',
  HEADER: 'Header',
  RIGHT_TO_BREED: 'Right to Breed',
  SPLASH: 'Splash Header',
  GOOD_BREEDER: 'How to become a good breeder'
};
